import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isExists',
  pure: false
})
export class IsExistsPipe implements PipeTransform {

  transform(items: any[], attr: string, value: string): boolean {
    return items != null && items.filter(x => x[attr] == value).length > 0;
  }

}
